export class SC_ForceType {
    static readonly NULL = 0;
    static readonly TOTAL_FAILURE = 1;
    static readonly INSITE_FAILURE = 2;
    static readonly OUT_FAILURE = 3;
    static readonly OUT_INSITE_FAILURE = 4;
    static readonly TRUANCY = 5;
    static readonly RESCHEDULED = 6;
    static readonly TRIP_CHARGE = 7;

    constructor(private type: number = SC_ForceType.NULL) { }

    static fromAPI(apiValue: number): SC_ForceType {
        switch (apiValue) {
            case SC_ForceType.TOTAL_FAILURE:
                return new SC_ForceType(SC_ForceType.TOTAL_FAILURE);
            case SC_ForceType.INSITE_FAILURE:
                return new SC_ForceType(SC_ForceType.INSITE_FAILURE);
            case SC_ForceType.OUT_FAILURE:
                return new SC_ForceType(SC_ForceType.OUT_FAILURE);
            case SC_ForceType.OUT_INSITE_FAILURE:
                return new SC_ForceType(SC_ForceType.OUT_INSITE_FAILURE);
            case SC_ForceType.TRUANCY:
                return new SC_ForceType(SC_ForceType.TRUANCY);
            case SC_ForceType.RESCHEDULED:
                return new SC_ForceType(SC_ForceType.RESCHEDULED);
            case SC_ForceType.TRIP_CHARGE:
                return new SC_ForceType(SC_ForceType.TRIP_CHARGE);
            default:
                return new SC_ForceType();
        }
    }

    is(type: number): boolean {
        return this.type === type;
    }

    toAPI(): number {
        return this.type;
    }

    clone(): SC_ForceType {
        return new SC_ForceType(this.type);
    }

    merge(other: SC_ForceType): SC_ForceType {
        if (other.type !== SC_ForceType.NULL) {
            this.type = other.type;
        }

        return this;
    }

    get isWorky() {
        switch (this.type) {
            case SC_ForceType.NULL:
            case SC_ForceType.TOTAL_FAILURE:
            case SC_ForceType.INSITE_FAILURE:
            case SC_ForceType.OUT_FAILURE:
            case SC_ForceType.OUT_INSITE_FAILURE:
                return true;
            case SC_ForceType.TRUANCY:
            case SC_ForceType.RESCHEDULED:
            case SC_ForceType.TRIP_CHARGE:
            default:
                return false;
        }
    }

    toString(): string {
        switch (this.type) {
            case SC_ForceType.TOTAL_FAILURE:
                return "Total Failure";
            case SC_ForceType.INSITE_FAILURE:
                return "Insite Failure";
            case SC_ForceType.OUT_FAILURE:
                return "Out Failure";
            case SC_ForceType.OUT_INSITE_FAILURE:
                return "Out Insite Failure";
            case SC_ForceType.TRUANCY:
                return "Work Not Completed";
            case SC_ForceType.RESCHEDULED:
                return "Rescheduled";
            case SC_ForceType.TRIP_CHARGE:
                return "Cancelled: Trip Charge";
            default:
                return "Not Set";
        }
    }
}
